<template>
  <div class="product-member-area-comments-list">
    <div class="row align-items-center justify-content-between">
      <div class="col-lg-3 order-1 order-lg-0 my-6 my-lg-0">
        <span class="table-quantity-counter mr-5">
          Total: {{ pagination.count || 0 }}
        </span>
        <button class="btn p-0 table-refresh" @click="refresh">
          <i class="fa-solid fa-refresh" />
        </button>
      </div>
      <div class="col-lg-6 d-lg-flex align-items-center">
        <div class="d-flex flex-fill">
          <search-filter
            new-design
            placeholder="E-mail, nome do aluno"
            class="mb-3 mb-lg-0 flex-fill"
            :showResultsDropdown="false"
            @search="searching"
          />
          <filter-button
            button-class="btn-40 btn-square ml-3 btn-new-outline-primary btn-sm"
            description
          >
            <template #default="{close}">
              <comments-filter
                v-model="params"
                @close="close"
                @input="dispatch"
              />
            </template>
          </filter-button>
        </div>

        <div class="d-flex flex-column flex-lg-row">
          <button
            v-if="status === 'published'"
            class="btn btn-sm btn-40 btn-secondary my-5 my-lg-0 px-3 ml-lg-3"
            :disabled="!checkedComments.length || loadingUpdate"
            @click="updateSelected('blocked')"
          >
            <b-spinner v-if="loadingUpdate" />
            <template v-else>
              <i class="fa fa-eye-slash pl-2" />
              <span class="px-5">
                Ocultar
              </span>
            </template>
          </button>
          <button
            v-else
            class="btn btn-sm btn-40 btn-success my-5 my-lg-0 px-3 ml-lg-3"
            :disabled="!checkedComments.length || loadingUpdate"
            @click="updateSelected('published')"
          >
            <b-spinner v-if="loadingUpdate" />
            <template v-else>
              <i class="fa fa-check pl-2" />
              <span class="px-5">
                Aprovar
              </span>
            </template>
          </button>
          <button
            class="btn btn-sm btn-40 btn-danger px-3 ml-lg-3"
            :disabled="!checkedComments.length || loadingDelete"
            @click="deleteSelected"
          >
            <b-spinner v-if="loadingDelete" />
            <template v-else>
              <i class="fa-solid fa-trash pl-2" />
              <span class="px-5">
                Excluir
              </span>
            </template>
          </button>
        </div>
      </div>
    </div>

    <div v-if="loading" class="text-center my-9">
      <b-spinner variant="primary" />
    </div>

    <div v-else-if="!comments.length" class="container centering text-center">
      <img
        class="d-block my-9 mx-auto"
        src="@/assets/images/home/welcome.svg"
      />
      <div class="text-secondary mb-9">
        Nenhum comentário não lido
      </div>
    </div>

    <template v-else>
      <b-checkbox
        class="mt-6 mb-5"
        v-model="allChecked"
        @change="checkAll"
        :indeterminate="indeterminated"
      >
        {{ allChecked ? "Desmarcar" : "Selecionar" }} todos
      </b-checkbox>
      <div
        v-for="comment in comments"
        class="d-flex align-items-center mt-5"
        :key="comment.id"
      >
        <bp-tooltip
          text="Aprove o comentário principal para manipular esta resposta."
          v-if="comment.parent_id && comment.parent.status !== 'published'"
        >
          <b-checkbox class="mr-sm-3" v-model="comment.checked" disabled />
        </bp-tooltip>

        <b-checkbox class="mr-sm-3" v-else v-model="comment.checked" />
        <comment-card
          class="flex-fill"
          :comment="comment"
          @reply="openReply"
          @refresh="refresh"
          @delete="deleteComment"
          @update="update"
        />
      </div>
    </template>

    <div class="d-flex justify-content-end mt-6">
      <paginator
        v-show="!loading && comments.length"
        :pagination="pagination"
        @on-update="onPaginationUpdate"
      />
    </div>

    <responsive-modal v-model="reply.dialog" size="lg">
      <reply-comment
        :mainComment="reply.comment"
        @delete="deleteComment"
        @update="isUpdated = true"
        @close="reply.dialog = false"
        @publish="update"
      />
    </responsive-modal>

    <confirmation
      v-model="confirmation"
      new-design
      confirm-button-class="btn-danger"
      text="Excluir comentário?"
      @confirm="remove(editedItem)"
    />
  </div>
</template>

<script>
import CommentCard from "./CommentCard";
import CommentsFilter from "./CommentsFilter";
import ReplyComment from "./ReplyComment";

import { clearObject } from "@/functions/helpers";
export default {
  props: {
    status: String
  },
  components: { ReplyComment, CommentsFilter, CommentCard },
  data() {
    return {
      comments: [],
      loading: false,
      allChecked: false,
      loadingUpdate: false,
      loadingDelete: false,
      confirmation: false,
      isUpdated: false,
      editedItem: null,
      pagination: {
        count: 0
      },
      reply: {
        dialog: false,
        comment: null
      },
      params: {
        product_id: this.$route.params.id,
        status: this.status,
        search: "",
        offset: 0,
        lesson__id: null,
        module__id: null
      }
    };
  },
  computed: {
    checkedComments() {
      return this.comments.filter(c => c.checked);
    },
    indeterminated() {
      return !!(
        this.comments.find(c => c.checked) &&
        this.comments.find(c => !c.checked)
      );
    }
  },
  watch: {
    indeterminated(val) {
      this.allChecked = val;
    },
    "reply.dialog"(v) {
      if (!v && this.isUpdated) {
        this.isUpdated = false;
        this.refresh();
      }
    }
  },
  mounted() {
    this.dispatch();
  },
  methods: {
    checkAll(v) {
      if (v) {
        this.comments = this.comments.map(c => ({
          ...c,
          checked:
            (c.parent_id && c.parent?.status === "published") || !c.parent_id
        }));
      } else
        this.comments = this.comments.map(c => ({
          ...c,
          checked: v
        }));
    },
    onPaginationUpdate(offset) {
      this.params.offset = offset;
      this.refresh();
    },
    searching(v) {
      this.params.search = v;
      this.dispatch();
    },
    refresh() {
      this.dispatch();
    },
    dispatch() {
      this.comments = [];
      this.loading = true;
      this.$store
        .dispatch("membersComments/getAll", clearObject(this.params))
        .then(({ data: { next, previous, count, results } }) => {
          this.comments = results.map(c => ({ ...c, checked: false }));
          this.pagination = { next, previous, count };
        })
        .finally(() => {
          this.loading = false;
        });
    },
    deleteComment(comment) {
      this.editedItem = comment;
      this.confirmation = true;
    },
    openReply(comment) {
      this.reply.comment = comment;
      this.reply.dialog = true;
    },
    update(status, id) {
      this.loading = true;
      this.$store
        .dispatch("membersComments/update", {
          id,
          status
        })
        .then(() => {
          this.refresh();
        })
        .catch(() => this.$message.error("Erro ao atualizar comentário"))
        .finally((this.loading = false));
      this.loading = false;
    },
    updateSelected(status) {
      this.loadingUpdate = true;
      this.$store
        .dispatch("membersComments/updateMany", {
          comments: this.checkedComments.map(comment => ({
            id: comment.id,
            status
          }))
        })
        .then(() => this.refresh())
        .catch(() => this.$message.error("Erro ao atualizar comentários"))
        .finally(() => {
          this.loadingUpdate = false;
        });
    },
    deleteSelected() {
      this.loadingDelete = true;
      this.$store
        .dispatch("membersComments/deleteMany", {
          comments_ids: this.checkedComments.map(c => c.id)
        })
        .then(() => this.refresh())
        .catch(() => this.$message.error("Erro ao apagar comentários"))
        .finally(() => {
          this.loadingDelete = false;
        });
    },
    remove(comment) {
      if (this.reply.dialog) this.reply.dialog = false;

      this.$store
        .dispatch("membersComments/remove", comment.id)
        .then(this.refresh)
        .catch(() => this.$message.error("Erro ao apagar comentário"));
    }
  }
};
</script>

<style lang="scss" scoped>
.product-member-area-comments-list {
  max-width: calc(100% - 24px);
  .btn-success {
    background-color: #006b20e0;
    border-color: #006b20e0;
    &:hover:not(:disabled) {
      background-color: #006b20;
      border-color: #006b20;
    }
  }
  .btn-danger {
    background-color: #d0000ee0;
    border-color: #d0000ee0;
    &:hover:not(:disabled) {
      background-color: #d0000e;
      border-color: #d0000e;
    }
  }
  .btn-secondary {
    background-color: #57586be0;
    border-color: #57586be0;
    &:hover:not(:disabled) {
      background-color: #57586b;
      border-color: #57586b;
    }
  }
}
</style>
